export const formatMonthlyInterestText = (monthlyInterest: number) => {
  return (
    Number(monthlyInterest.toFixed(2)).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + '% a.m.'
  )
}
